import React from 'react';
import Container from './Container';
import { LuFacebook } from 'react-icons/lu';
import { BsInstagram, BsTwitterX } from 'react-icons/bs';
import { SlSocialLinkedin } from 'react-icons/sl';

export default function Footer() {
  return (
    <footer className="bg-background border-b py-12 pb-8">
      <Container>
        <div className="flex items-center justify-between mb-2 md:mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-16 mb-8">
            <div>
              <h3 className="font-montserrat font-extrabold text-lg md:text-[22px] tracking-[-0.42px] leading-[36.44px] text-[#FF8D28] align-middle"
              >Easy <span className='text-[#000000] font-extrabold'>Suite</span></h3>
              <p className="font-segoe font-regular leading-[26px] tracking-[0%] align-middle text-[#717182] text-[17px] pt-0 md:pt-2">
                La suite d'applications africaines pour gagner du
                temps et simplifier votre quotidien.
              </p>
              <div className="flex gap-4 mt-5">
                <a href="#" className="w-10 h-10 rounded-[8px] border border-border bg-[#ECECF0] flex items-center justify-center hover:bg-muted transition-colors">
                  <LuFacebook className="w-5 h-5 text-[#717182]" />
                </a>
                <a href="#" className="w-10 h-10 rounded-[8px] border border-border bg-[#ECECF0] border border-border flex items-center justify-center hover:bg-muted transition-colors">
                  <BsTwitterX className="w-4 h-4 text-[#717182]" />
                </a>
                <a href="#" className="w-10 h-10 rounded-[8px] border border-border bg-[#ECECF0] border border-border flex items-center justify-center hover:bg-muted transition-colors">
                  <SlSocialLinkedin className="w-4.5 h-4.5 text-[#717182]" />
                </a>
                <a href="#" className="w-10 h-10 rounded-[8px] border border-border bg-[#ECECF0] border border-border flex items-center justify-center hover:bg-muted transition-colors">
                  <BsInstagram className="w-5 h-5 text-[#717182]" />
                </a>
              </div>
            </div>
            <div>
              <h3 className="font-segoe font-normal text-md md:text-lg leading-[38px] tracking-[0%] align-middle text-[#0A0A0A]">Liens rapides</h3>
              <ul className="space-y-2 font-segoe font-regular leading-[26px] tracking-[0%] align-middle text-[#717182] text-[17px] pt-1 md:pt-4">
                <li><a href="#" className="hover:text-primary transition-colors">Accueil</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Applications</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Tarifs</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Documentation</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-segoe font-normal text-md md:text-lg md:leading-[38px] tracking-[0%] align-middle text-[#0A0A0A]">Contact</h3>
              <ul className="space-y-2 font-segoe font-regular leading-[26px] tracking-[0%] align-middle text-[#717182] text-[17px] pt-2 md:pt-4">
                <li>contact@easysuite.africa</li>
                <li>Dakar, Sénégal</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="font-segoe font-regular leading-[36.36px] tracking-[0%] align-middle text-[#717182] text-xl border-t pt-8 text-center">
          <p>© 2025 Easy Suite. Tous droits réservés. Made with ❤️ in Africa.</p>
        </div>
      </Container>
    </footer>
  );
}


